import { Injectable } from '@angular/core';
import { IContext, IContextContactInfo } from '@ext-interfaces/context.model';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ContextService {
    public readonly $contactInfo: Observable<IContextContactInfo | undefined>;

    // IContext is in charge of pulling contact information based on the context of the app (e.g. Outlook === Email context).
    // IContext is abstracted out and injected dynamically, since we only care about getting contact info and not how we get it.
    constructor(private IContext: IContext) {
        this.$contactInfo = IContext.$contactInfo;
    }
}
